export default "__VITE_ASSET__DgOxMxOC__"